// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1rls3","file":"styles_file__39Dq-"};